export const DELETE_REMOVE_STOCK_REASON_MUTATION = gql`
    mutation deleteRemoveStockReason($id: Int!) {
        deleteRemoveStockReason(id: $id) {
            id
        }
    }
`;

export const CREATE_REMOVE_STOCK_REASON_MUTATION = gql`
    mutation createRemoveStockReason($input: CreateRemoveStockReasonInput!) {
        createRemoveStockReason(input: $input) {
            description
        }
    }
`;
